var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.isloading == true
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c(
                "button",
                { staticClass: "btn btn-theme", on: { click: _vm.cerrar } },
                [_vm._v("Cerrar")]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.transport.document.name)
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.transport.ticket_number)
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.transport.employee.person.name
                          )
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.transport.transportDate)
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.transport.place_send.name)
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.transport.place_rece.name)
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(7),
                      _vm._v(" "),
                      _vm.transport.description == null
                        ? _c("p", [_vm._v("Sin descripción")])
                        : _c("p", {
                            domProps: {
                              textContent: _vm._s(_vm.transport.description)
                            }
                          })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.transport.state == 0
                        ? _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                            _vm._v("Cancelado")
                          ])
                        : _vm.transport.state == 1
                        ? _c("span", { staticClass: "btn btn-info btn-sm" }, [
                            _vm._v("Pendiente")
                          ])
                        : _vm.transport.state == 2
                        ? _c(
                            "span",
                            { staticClass: "btn btn-success btn-sm" },
                            [_vm._v("Completo")]
                          )
                        : _vm.transport.state == 3
                        ? _c(
                            "span",
                            { staticClass: "btn btn-warning btn-sm" },
                            [_vm._v("Incompleto")]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Productos")]),
                      _vm._v(" "),
                      _c(
                        "table-component",
                        {
                          attrs: {
                            data: _vm.detailTransactionsArray,
                            "show-filter": false,
                            "table-class": "table"
                          }
                        },
                        [
                          _c("table-column", {
                            attrs: { show: "amount", label: "cantidad enviada" }
                          }),
                          _vm._v(" "),
                          _vm.transport.state == 1
                            ? _c("table-column", {
                                attrs: {
                                  sortable: false,
                                  filterable: false,
                                  label: "Cantida que llegó"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          row["state"] == 0
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.number",
                                                    value:
                                                      _vm
                                                        .detailTransactionsArray[
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      ].arrivedAmount,
                                                    expression:
                                                      "detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].arrivedAmount",
                                                    modifiers: { number: true }
                                                  }
                                                ],
                                                ref:
                                                  "arrivedAmount-" +
                                                  _vm.getIndex(
                                                    _vm.detailTransactionsArray,
                                                    row["id"]
                                                  ),
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid":
                                                    _vm.detailTransactionsArray[
                                                      _vm.getIndex(
                                                        _vm.detailTransactionsArray,
                                                        row["id"]
                                                      )
                                                    ].error === true
                                                },
                                                attrs: {
                                                  disabled: "",
                                                  type: "number"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.detailTransactionsArray[
                                                      _vm.getIndex(
                                                        _vm.detailTransactionsArray,
                                                        row["id"]
                                                      )
                                                    ].arrivedAmount
                                                },
                                                on: {
                                                  blur: [
                                                    function($event) {
                                                      _vm.validateQuantity(
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  ],
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm
                                                        .detailTransactionsArray[
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      ],
                                                      "arrivedAmount",
                                                      _vm._n(
                                                        $event.target.value
                                                      )
                                                    )
                                                  }
                                                }
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.number",
                                                    value:
                                                      _vm
                                                        .detailTransactionsArray[
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      ].arrivedAmount,
                                                    expression:
                                                      "detailTransactionsArray[getIndex(detailTransactionsArray,row['id'])].arrivedAmount",
                                                    modifiers: { number: true }
                                                  }
                                                ],
                                                ref:
                                                  "arrivedAmount-" +
                                                  _vm.getIndex(
                                                    _vm.detailTransactionsArray,
                                                    row["id"]
                                                  ),
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid":
                                                    _vm.detailTransactionsArray[
                                                      _vm.getIndex(
                                                        _vm.detailTransactionsArray,
                                                        row["id"]
                                                      )
                                                    ].error === true
                                                },
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    _vm.detailTransactionsArray[
                                                      _vm.getIndex(
                                                        _vm.detailTransactionsArray,
                                                        row["id"]
                                                      )
                                                    ].arrivedAmount
                                                },
                                                on: {
                                                  blur: [
                                                    function($event) {
                                                      _vm.validateQuantity(
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  ],
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm
                                                        .detailTransactionsArray[
                                                        _vm.getIndex(
                                                          _vm.detailTransactionsArray,
                                                          row["id"]
                                                        )
                                                      ],
                                                      "arrivedAmount",
                                                      _vm._n(
                                                        $event.target.value
                                                      )
                                                    )
                                                  }
                                                }
                                              })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  321028657
                                )
                              })
                            : _c("table-column", {
                                attrs: {
                                  sortable: false,
                                  filterable: false,
                                  show: "arrivedAmount",
                                  label: "Cantida que llegó"
                                }
                              }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              show: "stocksend.product.name",
                              label: "Producto"
                            }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              show: "stocksend.measure.equal",
                              label: "Medida"
                            }
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              sortable: false,
                              filterable: false,
                              label: "Estado"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(row) {
                                    return [
                                      _vm.transport.state == 0
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              { staticClass: "btn btn-danger" },
                                              [_vm._v("Cancelado")]
                                            )
                                          ])
                                        : _c("div", [
                                            row["state"] == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "btn btn-info"
                                                  },
                                                  [_vm._v("Llegó")]
                                                )
                                              : row["state"] == 2
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "btn btn-warning"
                                                  },
                                                  [_vm._v("Incompleto")]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger"
                                                  },
                                                  [_vm._v("No llegó")]
                                                )
                                          ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              732466392
                            )
                          }),
                          _vm._v(" "),
                          _c("table-column", {
                            attrs: {
                              sortable: false,
                              filterable: false,
                              label: "Acciones"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(row) {
                                    return [
                                      _vm.transport.state == 1
                                        ? _c("div", [
                                            row["state"] == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top-center",
                                                        value:
                                                          "El producto no llegó",
                                                        expression:
                                                          "'El producto no llegó'",
                                                        modifiers: {
                                                          "top-center": true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-warning",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openModal(
                                                          "didnt",
                                                          row["id"]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-ban"
                                                    })
                                                  ]
                                                )
                                              : _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top-center",
                                                        value:
                                                          "El producto si llegó",
                                                        expression:
                                                          "'El producto si llegó'",
                                                        modifiers: {
                                                          "top-center": true
                                                        }
                                                      }
                                                    ],
                                                    staticClass: "btn btn-info",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openModal(
                                                          "did",
                                                          row["id"]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-check"
                                                    })
                                                  ]
                                                )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1412438203
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.transport.state == 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { slot: "button", type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.openModal("shipment")
                              }
                            },
                            slot: "button"
                          },
                          [_vm._v(" Completar envio ")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        : _c(
            "div",
            { staticClass: "spinner-border", attrs: { role: "status" } },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
          ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "activate_modal",
          attrs: { icon: "info", "hide-close-button": "", blocking: "" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.modalTitleActivate) + "\n    "),
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.activate_modal.close()
                }
              },
              slot: "button"
            },
            [_vm._v("No")]
          ),
          _vm._v(" "),
          _vm.typeAction == 1
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { slot: "button", type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.productDidntArrive(_vm.id)
                    }
                  },
                  slot: "button"
                },
                [_vm._v("Si")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.typeAction == 2
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { slot: "button", type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.productDidArrive(_vm.id)
                    }
                  },
                  slot: "button"
                },
                [_vm._v("Si")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.typeAction == 3
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success ladda-button",
                  attrs: {
                    slot: "button",
                    type: "button",
                    "data-style": "expand-right"
                  },
                  on: {
                    click: function($event) {
                      return _vm.saveShipment()
                    }
                  },
                  slot: "button"
                },
                [_vm._v("Si")]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [
        _vm._v("Transporte de productos")
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Productos")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Transporte")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Documento")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("No. de transporte")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Empleado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Fecha")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Envia")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Recibe")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Descripción")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Estado")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fafb2c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fafb2c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/transport/Shipment.vue
// module id = 573
// module chunks = 0